import { CUSTOM_FILTERS } from "@/config/list";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { ListFilters } from "@/types/list";

type ActiveFilterProps = {
	filter: ListFilters;
};

const OPTIONS: { label: string; value: string }[] = [
	{ label: "Active", value: "active" },
	{ label: "Deactivated", value: "inactive" },
	{ label: "All", value: "all" },
];

export const ActiveFilter = ({ filter }: ActiveFilterProps) => {
	const value = (filter.getFilter(CUSTOM_FILTERS.isActive) as string | undefined) ?? "active";

	const onChange = (selected: string) => {
		if (selected === "active") {
			filter.clearFilter(CUSTOM_FILTERS.isActive);
		} else {
			filter.setFilter(CUSTOM_FILTERS.isActive, selected);
		}
	};

	const activeLabel = OPTIONS.find(option => option.value === value)?.label ?? "Active";

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Activity</span>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start">
							<span className="font-semibold">{activeLabel}</span>
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="start">
						{OPTIONS.map(option => (
							<DropdownMenuItem
								key={option.value}
								onSelect={() => onChange(option.value)}
								className={option.value === value ? "font-semibold bg-muted" : ""}
							>
								{option.label}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
